<script>
import axios from 'axios'
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import CpuWireframe from '@/vcs/_shared/cpu-wireframe/cmp.vue'
import { XIcon } from 'vue-feather-icons'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import ModalMixin from '@/mixins/ModalMixin.js'

export default {
  components: { XIcon, CpuWireframe },
  extends: BaseModal,
  mixins: [ModalMixin],
  data: function () {
    return {
      selectedCpu: null,
      currentParam: ''
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp'
    })
  },
  mounted() {
    this.selectedCpu = this.cp.units.filter((cpu) => {
      return _.map(cpu.boxes, 'id').indexOf(this.data.boxId) != -1
    })[0]
  },
  methods: {
    calculateCpHeight(cp) {
      if (cp.dimensions) {
        return parseInt(cp.dimensions.split(',')[1])
      }
    },
    deliveryResolve(param) {
      this.$blockUI()
      axios({
        method: 'put',
        url: `delivery_requests/${this.data.deliveryId}/resolve`,
        params: {
          resolve_type: param
        },
        headers: {
          common: {
            Authorization: `Bearer ${window.localStorage.getItem(
              'support_session_token'
            )}`
          }
        }
      })
        .then((response) => {
          this.close(true)
        })
        .catch((error) => {
          let errorCode = Object.values(
            (((error || {}).response || {}).data || {}).errors
          )
          // INFO: special case for `completed`
          if (errorCode == 'dr:7' && param == 'completed') {
            this.openCloseLockerPromptModal(this.$t('CLOSE_LOCKER_MESSAGE'), () => {
              this.deliveryResolve(param)
            })
          } else {
            this.$errorHumanized(error)
          }
        })
        .finally(() => {
          this.$unblockUI()
        })
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    x-icon(size="1.5x" @click="close()")
  .modal-body
    .row
      .col-9
        h1.page__header {{ $t('support.deliveryRequests.supportOpenLockerModal.header') }}
        h3.page__description.mb-5 {{ $t('support.deliveryRequests.supportOpenLockerModal.subheader') }}
      .col-3
        .cpu-thumbnails(v-if="cp && data.boxId && selectedCpu")
          cpu-wireframe(
            v-for="cpu in cp.units"
            :key="cpu.id"
            :cpu="cpu"
            :cpHeight="calculateCpHeight(cp)"
            :cpOperationKind="cp.operationKind"
            :forcedHeight="80"
            :openedBoxId="data.boxId || ''"
            :isSelected="cpu.id == selectedCpu.id"
            :displayIcons="false"
          )
    .row
      .col-3.button-wrapper
        template(v-if="data.status == 'service_required'")
          button.btn.btn-primary.btn-block.text-white.mb-4(
            v-ea-click="() => {deliveryResolve('completed')}"
          ) {{ $t('support.deliveryRequests.supportOpenLockerModal.deliveryCompleteButton') }}
          button.btn.btn-primary.btn-block.text-white.mb-4(
            v-ea-click="() => {deliveryResolve('failed')}"
          ) {{ $t('support.deliveryRequests.supportOpenLockerModal.deliveryCancelButton') }}
          button.btn.btn-primary.btn-block.text-white.mb-4(
            v-ea-click="() => {deliveryResolve('removed')}"
          ) {{ $t('support.deliveryRequests.supportOpenLockerModal.deliveryCompleteForClientButton') }}

        template(v-if="data.status == 'completed'")
          button.btn.btn-primary.btn-block.text-white.mb-4(
            v-ea-click="() => {deliveryResolve('removed')}"
          ) {{ $t('support.deliveryRequests.supportOpenLockerModal.deliveryCompleteForClientButton') }}

        template(v-if="data.status == 'not_collected'")
          button.btn.btn-primary.btn-block.text-white.mb-4(
            v-ea-click="() => {deliveryResolve('removed')}"
          ) {{ $t('support.deliveryRequests.supportOpenLockerModal.emptyLockerButton') }}

      .col-4.offset-1
        .selected-cpu(v-if="cp && data.boxId && selectedCpu")
          cpu-wireframe(
            v-if="!!selectedCpu"
            :cpu="selectedCpu"
            :cpHeight="calculateCpHeight(cp)"
            :cpOperationKind="cp.operationKind"
            :forcedHeight="300"
            :openedBoxId="data.boxId || ''"
            :isSelected="true"
          )
</template>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.cpu-thumbnails {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
}
.selected-cpu {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
